import { Flex, Icon, Text, TextProps } from "@chakra-ui/react";
import React from "react";
import EyeIcon from "../../../icons/EyeIcon";
import EyeOffIcon from "../../../icons/EyeOffIcon";

function replaceTextExceptLastX(
  text: string,
  replace: string,
  exceptLastX: number,
) {
  const __text = text || "";
  const lastText = __text.substring(__text.length - exceptLastX);
  return (
    __text
      .replace(/[a-z0-9]/gim, replace)
      .replace(/\s+/g, replace)
      .slice(0, -exceptLastX) + lastText
  );
}

interface HiddenTextProps extends TextProps {
  value: string | null | undefined;
  showLast: number;
}

export const HiddenText = ({ value, showLast, ...rest }: HiddenTextProps) => {
  const [show, setShow] = React.useState(false);
  if (!value) return <></>;
  const v = !show ? replaceTextExceptLastX(value, "•", showLast) : value;
  return (
    <Flex alignItems="center">
      <Text {...rest}>{v}</Text>
      <Icon
        data-testid="hidden-text-toggle"
        color="text.grey"
        ml="8px"
        cursor="pointer"
        as={show ? EyeOffIcon : EyeIcon}
        onClick={() => setShow(!show)}
      />
    </Flex>
  );
};
